import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const activityApi = generateNomenApi(`/nomen/activities`);

export const activityOptions = generateNomenOptions('activity', activityApi);
